import { useProducts } from '../hooks/useCatalog';
import { useWishlist } from '../context/WishlistContext';
import { Container } from '../components/ui/Container';
import { Eyebrow } from '../components/ui/Eyebrow';
import { ProductCard } from '../components/ProductCard';
import { ArrowLink } from '../components/ui/ArrowLink';

export function WishlistPage() {
  const { data: products, isLoading } = useProducts();
  const { ids } = useWishlist();

  const saved = (products ?? []).filter((p) => ids.includes(p.id));

  return (
    <Container className="py-16 md:py-20">
      <Eyebrow>Saved</Eyebrow>
      <h1 className="mt-5 font-serif text-4xl font-light text-ink md:text-5xl">Your Wishlist</h1>

      {isLoading && <p className="mt-10 text-sm text-stone">Loading…</p>}

      {!isLoading && saved.length === 0 && (
        <div className="mt-14 border-t border-stone-light pt-14">
          <p className="text-balance max-w-sm font-serif text-2xl font-light text-ink">
            Nothing saved yet — tap the heart on any print to keep it here.
          </p>
          <div className="mt-6">
            <ArrowLink to="/">Browse the collection</ArrowLink>
          </div>
        </div>
      )}

      {saved.length > 0 && (
        <div className="mt-12 grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-4">
          {saved.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </Container>
  );
}
